import "core-js/modules/es.array.push.js";
import { getCountry } from '@/api/user';
export default {
  name: 'Country',
  data: function data() {
    return {
      countryList: [{
        countryCode: '+86',
        country: 'China'
      }, {
        countryCode: '+46',
        country: 'China'
      }, {
        countryCode: '+47',
        country: 'China'
      }, {
        countryCode: '+48',
        country: 'China'
      }, {
        countryCode: '+49',
        country: 'China'
      }, {
        countryCode: '+50',
        country: 'China'
      }, {
        countryCode: '+51',
        country: 'China'
      }, {
        countryCode: '+52',
        country: 'China'
      }, {
        countryCode: '+53',
        country: 'China'
      }, {
        countryCode: '+54',
        country: 'China'
      }]
    };
  },
  created: function created() {
    var _this = this;
    getCountry().then(function (res) {
      console.log(res, 'res');
      if (res.code === 0) {
        _this.countryList = res.data.countryList;
      } else {
        _this.$toast(res.message);
      }
    });
  },
  methods: {
    getCountryCode: function getCountryCode(code, country) {
      localStorage.setItem('countryCode', code);
      localStorage.setItem('country', country);
      this.back();
    },
    back: function back() {
      this.$router.back();
    },
    toLogin: function toLogin() {
      this.$router.push({
        path: '/login'
      });
    }
  }
};